import axios from "axios";

export const BASE_URL = "https://youtube-v31.p.rapidapi.com";

const options = {
  params: { maxResults: 50 },
  headers: {
    "X-RapidAPI-Key": process.env.REACT_APP_RAPID_API_KEY,
    "X-RapidAPI-Host": "youtube-v31.p.rapidapi.com",
  },
};

export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}/${url}`, options);
  console.log(`Inside fetchFromAPI, complete serach URL : ${BASE_URL}/${url}`);
  console.log("Data fetched from URL :", data);
  return data;
};

// export const fetchFromAPI = async (url) => {
//   const data = {
//     kind: "youtube#searchListResponse",
//     nextPageToken: "CDIQAA",
//     pageInfo: { totalResults: 1000000, resultsPerPage: 50 },
//     regionCode: "US",
//     items: [
//       {
//         kind: "youtube#searchResult",
//         id: {
//           kind: "youtube#video",
//           videoId: "rOKCcYwFAyE",
//         },
//         snippet: {
//           publishedAt: "2025-06-11T20:30:43Z",
//           channelId: "UCBi2mrWuNuyYy4gbM6fU18Q",
//           title: "Georgie & Mandy's First Marriage",
//           description: "Georgie & Mandy's First Marriage",
//           thumbnails: {
//             default: {
//               url: "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcTwTPuG6Jvnh9I7LKk70RC4OWcRNcNdfOuzeoXYoV9VFLMXo6y_",
//               width: 120,
//               height: 90,
//             },
//             medium: {
//               url: "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcTwTPuG6Jvnh9I7LKk70RC4OWcRNcNdfOuzeoXYoV9VFLMXo6y_",
//               width: 320,
//               height: 180,
//             },
//             high: {
//               url: "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcTwTPuG6Jvnh9I7LKk70RC4OWcRNcNdfOuzeoXYoV9VFLMXo6y_",
//               width: 480,
//               height: 360,
//             },
//           },
//           channelTitle: "PS Video",
//           liveBroadcastContent: "none",
//           publishTime: "2025-06-11T20:30:43Z",
//         },
//       },
//       {
//         kind: "youtube#searchResult",
//         id: {
//           kind: "youtube#video",
//           videoId: "rOKCcYwFAyE",
//         },
//         snippet: {
//           publishedAt: "2025-06-11T20:30:43Z",
//           channelId: "UCBi2mrWuNuyYy4gbM6fU18Q",
//           title: "madagascar",
//           description: "madagascar",
//           thumbnails: {
//             default: {
//               url: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQElj-MbpTzoN8Qq2LBEvNsPA0Jh3OUXeCbyIw6tgTzfPfhMihC",
//               width: 120,
//               height: 90,
//             },
//             medium: {
//               url: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQElj-MbpTzoN8Qq2LBEvNsPA0Jh3OUXeCbyIw6tgTzfPfhMihC",
//               width: 320,
//               height: 180,
//             },
//             high: {
//               url: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQElj-MbpTzoN8Qq2LBEvNsPA0Jh3OUXeCbyIw6tgTzfPfhMihC",
//               width: 480,
//               height: 360,
//             },
//           },
//           channelTitle: "PS Video",
//           liveBroadcastContent: "none",
//           publishTime: "2025-06-11T20:30:43Z",
//         },
//       },
//       {
//         kind: "youtube#searchResult",
//         id: {
//           kind: "youtube#video",
//           videoId: "rOKCcYwFAyE",
//         },
//         snippet: {
//           publishedAt: "2025-06-11T20:30:43Z",
//           channelId: "UCBi2mrWuNuyYy4gbM6fU18Q",
//           title: "86 arrested at anti-ICE protest in New York City",
//           description:
//             "Thousands protesting President Donald Trump's immigration crackdown gathered in Lower Manhattan on Tuesday.",
//           thumbnails: {
//             default: {
//               url: "https://i.ytimg.com/vi/rOKCcYwFAyE/default.jpg",
//               width: 120,
//               height: 90,
//             },
//             medium: {
//               url: "https://i.ytimg.com/vi/rOKCcYwFAyE/mqdefault.jpg",
//               width: 320,
//               height: 180,
//             },
//             high: {
//               url: "https://i.ytimg.com/vi/rOKCcYwFAyE/hqdefault.jpg",
//               width: 480,
//               height: 360,
//             },
//           },
//           channelTitle: "ABC News",
//           liveBroadcastContent: "none",
//           publishTime: "2025-06-11T20:30:43Z",
//         },
//       },
//     ],
//   };

//   return data;
// };
